import { LuChevronLeft, LuChevronRight, LuPlus } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import { PageTitle } from '@/components/ui/page-title';

import { formatCalendarRangeHeader, stepAnchorDate } from '../calendar-range';
import { useEventCalendarViewState } from '../calendar-state';
import { EventCalendarActionMenu } from './EventCalendarActionMenu';
import { EventCalendarTypeFilter } from './EventCalendarTypeFilter';
import { MeetingMinutesListFilter } from './MeetingMinutesListFilter';

// Shared header for the CC_CALENDAR_NOTES tab pair. Unlike EventCalendar's internal header,
// navigation steps a page-owned anchorDate instead of calling FullCalendar's API, so the
// Calendar and Meeting Minutes tabs stay on the same range.
export const CalendarPageHeader = ({
    anchorDate,
    onAnchorDateChange,
    onNewEvent,
}: {
    anchorDate: Date;
    onAnchorDateChange: (anchorDate: Date) => void;
    onNewEvent: () => void;
}) => {
    const { eventCalendarViewState } = useEventCalendarViewState();
    const { activeTab, calendarView } = eventCalendarViewState;

    return (
        <div className="flex w-full items-center justify-between gap-8 py-4">
            <div className="flex items-center gap-4">
                <div className="border-cocoa-100 flex items-center gap-2 rounded-full border bg-white p-1">
                    <Button
                        variant="ghost2"
                        size="sm"
                        className="h-8 w-8 p-0"
                        onClick={() => onAnchorDateChange(stepAnchorDate(anchorDate, calendarView, -1))}
                    >
                        <LuChevronLeft />
                    </Button>
                    <Button
                        variant="ghost2"
                        size="sm"
                        className="h-8 w-8 p-0"
                        onClick={() => onAnchorDateChange(stepAnchorDate(anchorDate, calendarView, 1))}
                    >
                        <LuChevronRight />
                    </Button>
                </div>
                {/* min-w reserves title space so the right-side controls don't shift as the range text changes */}
                <div className="min-w-[240px]">
                    <PageTitle>{formatCalendarRangeHeader(anchorDate, calendarView)}</PageTitle>
                </div>
            </div>
            <div className="flex items-center gap-2">
                {activeTab === 'meetingMinutes' && <MeetingMinutesListFilter anchorDate={anchorDate} />}
                <EventCalendarTypeFilter />
                <EventCalendarActionMenu />
                <Button variant="outline2" size="sm" className="px-3" onClick={onNewEvent}>
                    <LuPlus className="h-4 w-4" /> Event
                </Button>
            </div>
        </div>
    );
};
